// extracted by mini-css-extract-plugin
export default {"flexCenter":"FooterComponent_flexCenter__FsEH2"};